import React, {Button, Component, useState } from "react";
import Utils from "../../../utils/utils";
// components
import PageTitle from "../../../components/PageTitle/PageTitle";
import Cookies from 'universal-cookie';
import LoadingOverlay from 'react-loading-overlay';
import Table from '../../../widgets/tables/Table';
import WaitDialog from '../../../widgets/WaitDialog';
import RataStatusWidget from '../../../widgets/RataStatusWidget';

import GetStudenti from '../../../services/getStudentiForBilling';
import getCorsi from '../../../services/getCorsi';
import getRataStatusAll from "../../../services/getRataStatusAll";
import getPianoPagamentiCorso from "../../../services/getPianoPagamentiCorso";
import getPianoPagamentiPersonalizzati from "../../../services/getPianoPagamentiPersonalizzati";
import moment from "moment";

export default class InRitardo extends React.Component {

  constructor(props){
    super (props)
  
    this.pageDiv = {
      border: '1px solid #cccccc',
      padding: 10
    };

    this.pageTitle = props.pageTitle;
    this.pageName = props.pageName;
    if (this.pageName == undefined){
      this.pageName = this.section;
    }

    this.options = [
      { value: 'All', label: 'All' }
    ]

    this.selectRef = React.createRef();

    this.state = {
      testo: '',
      menuBackground: '#ffffff',
      menuItemColor: '#000000',
      fontSize: 50,
      fontBold: false,
      logoPicture: '',
      logoMargin: 0,
      titleColor: '#000000',
      titleSize: 18,
      isLoading: false,
      addElementVisible: false,
      waitDialogVisible: false,
      mailCompaniesList: []
    }

    this.grid = 2;

    this.pdfElements = [];

    this.studenti = [];
    this.pageTitle = "Pagamenti in ritardo";
    this.brokerId = undefined;

    const cookies = new Cookies();
    var strJson = JSON.stringify({list: []});
    cookies.set('checksList', strJson, { path: '/' });
    
    this.sendMailRef = React.createRef();
    this.sendNotificationRef = React.createRef();

    this.state = {
      waitDialogVisible: true
    };

  }

  async reload(){

    this.setState({waitDialogVisible: true});

    const cookies = new Cookies();
    const username = cookies.get('username', { path: '/' });
    const token = cookies.get('token', { path: '/' });
    
    this.studenti = await GetStudenti(username, token);
    this.corsi = await getCorsi(username, token);
    
    this.pianoPagamentiPersonalizzati = await getPianoPagamentiPersonalizzati(username, token);
    this.rataStatus = await getRataStatusAll(username, token);

    this.dataCorrente = moment();
    this.dataCorrente.hour(0);
    this.dataCorrente.minutes(0);
    this.dataCorrente.seconds(0);

    this.inRitardo = [];
    this.indexInRitardo = 1;

    this.corsi = await getCorsi(username, token);
    for (var c of this.corsi){
      var idCorso = c.id;
      var pianoPagamentiCorso = await getPianoPagamentiCorso(username, token, idCorso);
      // if (pianoPagamentiCorso == undefined) continue;
      var rate = pianoPagamentiCorso ? pianoPagamentiCorso.rate : [];
      rate = rate.filter(r => {
        var data = r.data;
        data = moment(data, "DD-MM-yyyy");
        if (data < this.dataCorrente) return true;
        return false;
      })
      
      var studentiCorso = this.studenti.filter(s => Utils.hasCorso(s.corsi, idCorso));
      studentiCorso.forEach(studente => {

        var rateStudente = [];

        var pianoPersonalizzato = this.pianoPagamentiPersonalizzati.find(p => p.id_studente == studente.id && p.id_corso == idCorso);
        // se lo studente ha un piano personalizzato
        if (pianoPersonalizzato != undefined) {
          var piano = JSON.parse(pianoPersonalizzato.piano);
          rateStudente = piano.rate;
          rateStudente = rateStudente.filter(r => {
            var data = r.data;
            data = moment(data, "DD-MM-yyyy");
            if (data < this.dataCorrente) return true;
            return false;
          })
        } 
        // se non ho un piano personalizzato
        else {
          rateStudente = rate;
        }

        rateStudente.forEach(rataStudente => {
          var rataStatus = this.rataStatus.find(r => r.id_corso == idCorso && r.id_studente == studente.id && r.data == rataStudente.data && parseFloat(r.importo) == parseFloat(rataStudente.importo));
          if (rataStatus == undefined || rataStatus.status == 'NON PAGATA'){
            this.inRitardo.push({
              id: this.indexInRitardo,
              id_corso: idCorso,
              id_studente: studente.id,
              data: rataStudente.data,
              importo: rataStudente.importo,
              status: 'DA_PAGARE',
            });
            this.indexInRitardo++;
          }
        })

        
      });

    }
   
    this.inRitardo.forEach((rata, index) => {
      var studente = this.studenti.find(s => s.id == rata.id_studente);
      var corso = this.corsi.find(c => c.id == rata.id_corso);
      rata.nome = studente.nome;
      rata.cognome = studente.cognome;
      rata.corso = corso.name;

      this.inRitardo[index] = rata;
    });

    this.inRitardo.forEach((rata, index) => {
      var data = rata.data;

      data = moment(data, "DD-MM-yyyy").format("DD-MM-yyyy");
      rata.data = data;
      this.inRitardo[index] = rata;
    });


    this.setState({
      rataStatusWidgetVisible: false,
      waitDialogVisible: false
    });
  }

  async componentDidMount(){
    await this.reload();

  }


  render () {

    var headCells = [
      { id: 'nome', numeric: false, disablePadding: true, label: 'Nome' },
      { id: 'cognome', numeric: true, disablePadding: false, label: 'Cognome' },
      { id: 'corso', numeric: true, disablePadding: false, label: 'Corso' },
      { id: 'data', numeric: true, disablePadding: false, label: 'Data' },
      { id: 'importo', numeric: true, disablePadding: false, label: 'Importo' },
      { id: '_', numeric: true, disablePadding: false, label: '' },
    ];

    this.searchCols = ['nome', 'cognome', 'corso'];

    return (
      <>
      <LoadingOverlay
      active={this.state.isLoading}
      styles={{
        content: (base) => ({
          position: 'relative',
          width: '100%',
          top: '200px'
        })
      }}
      spinner
      text={'Loading your content...'}
      >
        <PageTitle title={this.pageTitle} />

        <Table headCells={headCells} searchCols={this.searchCols} calendar={false} pdf={false} excel={false} mail={false} phone={false} rows={this.inRitardo != undefined ? this.inRitardo : []} 
              onEventClick={(row) => {

                var rata = this.inRitardo.find(r => r.id == row);
                var studente = this.studenti.find(s => s.id == rata.id_studente);
                var corso = this.corsi.find(c => c.id == rata.id_corso);

                this.setState({
                  rataStatusWidgetVisible: true,
                  status: rata.status,
                  rata: {
                      studente: studente,
                      data: rata.data,
                      importo: rata.importo,
                      corso: corso,
                      files: rata.files,
                      note: rata.note
                  }
              });
              }}
        />

        <RataStatusWidget show={this.state.rataStatusWidgetVisible} rata={this.state.rata} status={this.state.status} 
            onClose={() => {
                this.setState({rataStatusWidgetVisible: false});
                this.reload();
            }}
        />

        <WaitDialog show={this.state.waitDialogVisible} key={Math.random()} index={this.state.index}/>
        </LoadingOverlay>
      </>
    );
  }
}

